import {
	type UsersListInput,
	UserType,
	type RoleListQueryVariables,
} from '@/generated/graphql';

export const USER_LIST_USERS_INPUT: UsersListInput = {
	filters: {
		userTypes: [UserType.User, UserType.Admin],
	},
};

export const ROLE_LIST_QUERY_VARIABLES: Pick<
	RoleListQueryVariables,
	'rolesListInput'
> = {
	rolesListInput: {
		filters: {
			isActive: true,
		},
	},
};

export const SWITCH_ITEM = {
	INDIVIDUALS: 'individuals',
	ROLES: 'roles',
} as const;

export const USER_GROUP = {
	PROJECT_MEMBERS: 'project_members',
	OTHER_USERS: 'other_users',
} as const;

export const INITIAL_USER_GROUP_DROPDOWN_STATE: Array<{
	id: string;
	isOpen: boolean;
}> = [
	{
		id: USER_GROUP.PROJECT_MEMBERS,
		isOpen: true,
	},
	{
		id: USER_GROUP.OTHER_USERS,
		isOpen: true,
	},
];
